import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GerenciaArquivo } from 'src/app/@shared/models/gerencia-arquivo/gerencia-arquivo';
import { StorageService } from 'src/app/services/storage/storage.service';
import { GerenciaArquivoService } from '../gerencia-arquivo.service';

@Component({
  selector: 'app-modal-cadastra-arquivo',
  templateUrl: './modal-cadastra-arquivo.component.html',
  styleUrls: ['./modal-cadastra-arquivo.component.scss']
})
export class ModalCadastraArquivoComponent implements OnInit {
  public form: FormGroup;
  files: any;
  usuario: any;
  public fileName: '';
  public gerenciaArquivo: GerenciaArquivo;

  constructor(private gerenciaArquivoService: GerenciaArquivoService,
    public dialogRef: MatDialogRef<ModalCadastraArquivoComponent>,
    public snackBar: MatSnackBar,
    private fb: FormBuilder,) { }

  ngOnInit(): void {
    this.usuario = StorageService.getPerfilUsuario();

    this.form = this.fb.group({
      cliente: ['', [Validators.required]],
      nomeArquivo: ['', Validators.required]
    });
  }
  get cliente() {
    return this.form.get('cliente').value;
  }
  get nomeArquivo() {
    return this.form.get('nomeArquivo').value;
  }


  onFileChange(ev): void {
    this.files = ev.target.files;
    this.fileName = this.files[0].name;
  }

  uploadImage(): void {
    if (this.files.length === 0) {
      return;
    }

    let fileToUpload = <File>this.files[0];
    const formData = new FormData();

    formData.append('file', fileToUpload, fileToUpload.name);

    this.gerenciaArquivoService.upLoadArquivo(formData).subscribe(obj => {

      let p = Object.assign({}, this.form.value);
      obj.clienteId = p.cliente.id;
      obj.usuario = this.usuario.username;
      obj.nomeArquivo = p.nomeArquivo;

      this.gerenciaArquivoService.registraArquivo(obj).subscribe(obj => {
        this.openSnackBar("Arquivo cadastrado com sucesso");
        this.dialogRef.close("Cadastrado com sucesso");
      }, error => {
        console.log(error)
      })
    }, error => {
      console.log(error)
    })
  }

  openSnackBar(message: string): any {
    this.snackBar.open(message, null, { duration: 5000 });
  }
}
